import HomeWrapEncrypted from './components/HomeWrapEncrypted';

const AppRoutes = [
  {
    index: true,
    element: <h1>Enter Valid encrypted URL</h1>
  },
  {
    path: ':encryptedBase/:iv',
    element: <HomeWrapEncrypted />
  },
];
export default AppRoutes;